import { SelectionModel } from '@angular/cdk/collections';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  ViewChild,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { AppScreenBase } from '@app/custom-shared/util/app-screen-base';
import { orderBy } from 'lodash';
import { CriarGruposDeInvestimentoComponent } from '../../criar-grupos-de-investimento/criar-grupos-de-investimento.component';
import { Fundo, Grupo } from './cliente-grupo-investimento.model';
import { ClienteGrupoInvestimentoService } from './services/cliente-grupo-investimento.service';
import { MatPaginator } from '@angular/material/paginator';


@Component({
  selector: 'app-cliente-grupo-investimento',
  templateUrl: './cliente-grupo-investimento.component.html',
  styleUrls: ['./cliente-grupo-investimento.component.scss'],
})
export class ClienteGrupoInvestimentoComponent extends AppScreenBase
  implements OnInit {
  dataSourceGrupos: MatTableDataSource<Grupo>;
  displayedColumnsGrupos: string[] = ['select', 'name'];
  selectionGrupos = new SelectionModel<Grupo>(true, []);

  dataSourceFundos = new MatTableDataSource<Fundo>();
  dataSourceFundosInit = new MatTableDataSource<Fundo>();
  displayedColumnsFundos: string[] = ['select', 'code', 'name'];
  selectionFundos = new SelectionModel<Fundo>(true, []);
  fundsComplete = [];
  groupsComplete = [];
  control: any;
  fundsSorted: boolean = false;

  newInvestmentGroup: Grupo = new Grupo();

  @Input() form: FormGroup;
  @Input() editar: boolean;
  @Input() id: any;
  @Output() hasSelectedGroups = new EventEmitter<boolean>();
  @ViewChildren(MatSort) sortFunds = new QueryList<MatSort>();
  @ViewChild('paginator') paginator: MatPaginator;

  constructor(
    private clienteGrupoInvestimentoService: ClienteGrupoInvestimentoService,
    private dialog: MatDialog,
  ) {
    super();
  }

  ngOnInit() {
    this.hasSelectedGroups.emit(this.selectionGrupos.hasValue());
    this.control = this.form.controls['investmentGroups'];
    this.getGrupos();
   // this.getFunds();
  }

  onClose(): void { }
  getGrupos(hasNewGroup?: boolean) {

  this.clienteGrupoInvestimentoService
      .getFunds()
      .subscribe(response => {
        const resp = response.naturalSort(['code']);
        this.dataSourceFundos = new MatTableDataSource(resp);
        this.dataSourceFundos.paginator = this.paginator
        this.dataSourceFundosInit= new MatTableDataSource(resp);
      
    this.clienteGrupoInvestimentoService
      .getInvestmentGroups()
      .then(response => {
        const resp = response.grupos.naturalSort(['name']);
        this.dataSourceGrupos = new MatTableDataSource(resp);
      })
      .then(() => {
        this.populateGroups();
        if (hasNewGroup) {
          this.dataSourceGrupos.data.forEach(group => {
            if (group.name === this.newInvestmentGroup.name) {
              this.selectionGrupos.toggle(group);
              this.changeGroup(null, group);
            }
          });
        }
      });
  })}

  populateGroups() {
    if (this.editar === true) {
      const payload = `{"id": "${this.id}"}`;

      this.clienteGrupoInvestimentoService.getUser(payload).then(response => {
        response.investmentGroups.forEach(group => {
          this.dataSourceGrupos.filteredData.forEach(item => {
            if (item.id === group.id) {
              this.selectionGrupos.select(item);
              let fundos = [];
              if (this.selectionGrupos.selected && this.selectionGrupos.selected.length) {
                this.selectionGrupos.selected.forEach(grupo => {
                  if (grupo.funds && grupo.funds.length) {
                    grupo.funds.forEach(fundo => {
                      if (fundo) {
                        fundos.push(fundo);
                      }

                    });
                  }

                });
              }

              const filteredFundos = fundos
                .filter((v, i, a) => a.findIndex(t => t.code === v.code) === i)
                .naturalSort(['code']);

              this.dataSourceFundos = new MatTableDataSource(filteredFundos);
              this.dataSourceFundos.paginator = this.paginator
              this.control.setValue(this.selectionGrupos.selected);
            }
          });
        });
      });
    }
    else{
      this.dataSourceFundos = this.dataSourceFundosInit
      this.dataSourceFundos.paginator = this.paginator
    }
  }

  masterToggleGrupos() {
    this.isAllSelectedGrupos()
      ? this.selectionGrupos.clear()
      : this.dataSourceGrupos.data.forEach(row =>
        this.selectionGrupos.select(row),
      );
  }

  isAllSelectedGrupos() {
    const numSelected = this.selectionGrupos.selected.length;
    const numRows =
      this.dataSourceGrupos != null ? this.dataSourceGrupos.data.length : 0;
    return numSelected === numRows;
  }

  checkboxLabelGrupos(row?: Grupo): string {
    if (!row) {
      return `${this.isAllSelectedGrupos() ? 'select' : 'deselect'} all`;
    }
    return `${this.selectionGrupos.isSelected(row) ? 'deselect' : 'select'
      } row ${row.name + 1}`;
  }

  isAllSelectedFundos() {
    const numSelected = this.selectionFundos.selected.length;
    const numRows =
      this.dataSourceFundos != null ? this.dataSourceFundos.data.length : 0;
    return numSelected === numRows;
  }

  masterToggleFundos() {
    this.isAllSelectedFundos()
      ? this.selectionFundos.clear()
      : this.dataSourceFundos.data.forEach(row =>
        this.selectionFundos.select(row),
      );
  }

  checkboxLabelFundos(row?: Fundo): string {
    if (!row) {
      return `${this.isAllSelectedFundos() ? 'select' : 'deselect'} all`;
    }
    return `${this.selectionFundos.isSelected(row) ? 'deselect' : 'select'
      } row ${row.code + 1}`;
  }

  applyFilterFundos(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceFundos.filter = filterValue.trim().toLowerCase();

    if (filterValue.length > 0 && filterValue.length % 2 == 0) {
      this.fundsComplete = this.dataSourceFundos.filteredData;
    } else if (filterValue.length == 0) {
      this.fundsComplete = [];
    }
  }

  checkGroup(event) {
    event.stopPropagation();
  }

  changeGroup($event, row) {
    $event ? this.selectionGrupos.toggle(row) : this.selectionGrupos.toggle(null);
    let fundos = [];
    this.selectionGrupos.selected.forEach(grupo => {
      if (grupo && grupo.funds) {
        grupo.funds.forEach(fundo => {
          fundos.push(fundo);
        });
      }

    });
    const filteredFundos = fundos.filter(
      (v, i, a) => a.findIndex(t => t.code === v.code) === i,
    );
    if (filteredFundos.length){
      this.dataSourceFundos = new MatTableDataSource(filteredFundos);
      this.dataSourceFundos.paginator = this.paginator
    }
    else{
      this.dataSourceFundos = this.dataSourceFundosInit
      this.dataSourceFundos.paginator = this.paginator
    }
    //this.dataSourceFundos = new MatTableDataSource(filteredFundos);
    const selected = this.selectionGrupos.selected;
    this.dataSourceFundos.data = this.dataSourceFundos.data.sort((a, b) => {
      return a.code.toLocaleLowerCase() > b.code.toLocaleLowerCase() ? 1 : -1;
    });
    this.control.setValue(selected);
    this.hasSelectedGroups.emit(this.selectionGrupos.hasValue());
  }

  applyFilterGroups(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSourceGrupos.filter = filterValue.trim().toLowerCase();

    if (filterValue.length > 0 && filterValue.length % 2 == 0) {
      this.groupsComplete = this.dataSourceGrupos.filteredData;
    } else if (filterValue.length == 0) {
      this.groupsComplete = [];
    }
  }

  openDialogCreateGroup() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.hasBackdrop = true;
    dialogConfig.height = '90vh';
    dialogConfig.width = '92vw';
    dialogConfig.maxWidth = '100vw';
    dialogConfig.position = {
      top: '83px',
    };

    const dialogRef = this.dialog.open(
      CriarGruposDeInvestimentoComponent,
      dialogConfig,
    );
    dialogRef.afterClosed().subscribe(investmentGroup => {
      console.log("isclose")
      console.log("IGs",investmentGroup)
      if (investmentGroup) {
        this.selectionFundos.clear()
        this.selectionGrupos.clear()
        this.dataSourceFundos.data=[]

        this.newInvestmentGroup = investmentGroup;
        this.getGrupos(true);
      } else {
        this.selectionFundos.clear()
        this.selectionGrupos.clear()
        this.dataSourceFundos.data=[]
      }
    });
  }

  filterColumnFunds(param) {
    this.fundsSorted = !this.fundsSorted;
    const order = this.fundsSorted ? 'desc' : 'asc';
    this.dataSourceFundos.data = orderBy(
      this.dataSourceFundos.data,
      param,
      order,
    );
  }
}
